/* Flashbang countdown. Markup comes from snippets/fb-countdown.liquid, already filled in by the
   server, so nothing shifts on load. This only keeps the numbers ticking and handles the end. */
(function () {
  if (customElements.get('fb-countdown')) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  class FbCountdown extends HTMLElement {
    connectedCallback() {
      this.end = parseInt(this.dataset.end, 10) * 1000;
      this.root = this.closest('[data-fb-countdown-root]');
      this.nums = {};
      this.querySelectorAll('[data-unit]').forEach((el) => { this.nums[el.dataset.unit] = el; });
      this.tick();
      if (!this.hasAttribute('data-ended')) this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() { clearInterval(this.timer); }

    tick() {
      const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      const parts = { d: Math.floor(left / 86400), h: Math.floor(left % 86400 / 3600), m: Math.floor(left % 3600 / 60), s: left % 60 };
      Object.keys(this.nums).forEach((k) => {
        const text = pad(parts[k]);
        if (this.nums[k].textContent !== text) this.nums[k].textContent = text;
      });
      this.setAttribute('aria-label', 'Time left: ' + parts.d + ' days, ' + parts.h + ' hours, ' + parts.m + ' minutes');
      if (left === 0) this.finish();
    }

    finish() {
      clearInterval(this.timer);
      this.setAttribute('data-ended', '');
      if (!this.root) return;
      this.root.classList.add('is-ended');
      // The theme editor keeps it visible so it can still be edited.
      if (this.dataset.afterEnd !== 'message' && !this.hasAttribute('data-editor')) this.root.hidden = true;
    }
  }

  customElements.define('fb-countdown', FbCountdown);
})();
